import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

const headerCartItemsCountElements = toArray(document.querySelectorAll('.js-header-cart-items'));

class Product extends Controller {
  onInputChange() {
    this.quantity = this.quantityTarget.value;
  }

  onCartClick(event) {
    const button = event.currentTarget;
    const id = button.getAttribute('data-variant-id');

    $.ajax({
      url: window.app.api.cartItemStore,
      type: 'POST',
      data: {
        product_variant_id: id,
        quantity: typeof this.quantity !== 'undefined' ? this.quantity : 1,
      },
      success: (res) => {
        headerCartItemsCountElements.forEach((headerCartItemsCountElement) => {
          headerCartItemsCountElement.innerHTML = res.cartItemsCount;
          headerCartItemsCountElement.classList.remove('d-none');
        });

        this.toggleAnimation(button);
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  toggleAnimation(button) {
    button.classList.add('is-successful');

    setTimeout(() => {
      button.classList.remove('is-successful');
    }, 1000);
  }
}

Product.targets = [
  'cartButton',
  'quantity',
];

export default Product;
